import React, { Component } from 'react';

import { ProjectLocationDetails } from 'lib/generated_constants/project_location_details';
import * as propTypes from 'lib/prop_types';

import { GoogleMap } from 'components/google_map';

class LocationDetail extends Component {
  static propTypes = {
    address: propTypes.string,
    location: propTypes.shape({
      latitude: propTypes.number,
      longitude: propTypes.number,
      name: propTypes.string,
    }).isRequired,
    locationDetail: propTypes.string.isRequired,
    showLabel: propTypes.bool,
  };

  static defaultProps = {
    showLabel: true,
  };

  get showMap() {
    const { latitude, longitude } = this.props.location;

    return latitude && longitude;
  }

  get mapCenter() {
    const { latitude, longitude } = this.props.location;

    return { lat: latitude, lng: longitude };
  }

  renderInPerson() {
    return (
      <>
        <p>
          The study will be conducted at the researcher&apos;s location in{' '}
          {this.props.location.name}.
        </p>

        {this.showMap && <GoogleMap center={this.mapCenter} withMarker />}

        {this.props.address && (
          <p className="LocationDetail__address">{this.props.address}</p>
        )}
      </>
    );
  }

  renderContent() {
    switch (this.props.locationDetail) {
      case ProjectLocationDetails.researcherLocation:
        return this.renderInPerson();
      case ProjectLocationDetails.participantWork:
        return <p>This study will be conducted at your workplace.</p>;
      case ProjectLocationDetails.participantHome:
        return <p>This study will be conducted at your home.</p>;
      case ProjectLocationDetails.toBeDetermined:
        return (
          <p>
            If you are accepted for the study, you will hear from the researcher
            about where the study will be conducted.
          </p>
        );
      default:
        return null;
    }
  }

  render() {
    return (
      // TODO RS-2398: While this component is rendered in an ERB template and the,
      // styles are affecting direct children, it has to remain a fragment as the
      // class has to be applied to the element wrapping this component.
      <>
        {this.props.showLabel && <dt>Location details</dt>}

        <dd>{this.renderContent()}</dd>
      </>
    );
  }
}

export default LocationDetail;
